$(document).ready(function(){

	var stream = {
		title: "",
		mp3: "https://sidescroller-play.wpcdn.pl/images/music.mp3"
	},
	ready = false;
    
	$("#jquery_jplayer_1").jPlayer({
		ready: function (event) {
			ready = true;
			//$(this).jPlayer("setMedia", stream); // - dla mini wyłączone, włączyć dla pozostałych realizacji  #sound, #dźwięk, #muted, #mute, #init, #sound, #player
            //$(this).jPlayer("play");  // - dla mini wyłączone, włączyć dla pozostałych realizacji  #sound, #dźwięk, #muted, #mute
		},
		pause: function() {
			$(this).jPlayer("clearMedia");
			statAction('button', 'audio off');
		},
		error: function(event) {
			if (ready && event.jPlayer.error.type === $.jPlayer.error.URL_NOT_SET) {
				// Setup the media stream again and play it.
				$(this).jPlayer("setMedia", stream).jPlayer("play");
				statAction('button', 'audio on');
			}
		},
		swfPath: "/js",
		supplied: "mp3",
		preload: "none",
		wmode: "window",
        volume: .05,
		useStateClassSkin: true,
		autoBlur: true,
		keyEnabled: true
	});


	/*
	
	//tip do dźwięku na star/pierwsze wejście
	var visited = WP.cookie.get('SScrVisited');
	var maxPopupViews = 3; // maksymalna liczba wyświetleń komunikatu
	
	//alert(visited);
    if (!visited || visited < maxPopupViews) {
		WP.cookie.set('SScrVisited', 1);
		console.log('nie obejrzane');
		if($('#jquery_jplayer_1').data().jPlayer.status.paused) { //gdy muzyka nie gra			
		 	//console.log('zoba jaki fajny dźwięk');
		 	document.getElementById("global--sidebar-popup").classList.add('__jsAnimation');
			document.getElementById("global--darkSide").classList.add('__jsVisible');
			setTimeout(function(){				
				document.getElementById("global--darkSide").classList.remove('__jsVisible');
			}, 3000);
		}
		visited++;
		WP.cookie.set('SScrVisited', visited);
    } 
	else {
		document.getElementById("global--sidebar-popup").classList.remove('__jsAnimation');
		//console.log('tip obejrzany wystarczającą ilość razy');
		document.getElementById("global--darkSide").classList.remove('__jsVisible');			 
	}

	//tip do przewijania
	var visitedTip2 = WP.cookie.get('SScrVisited2');
	var maxPopupViews2 = 3; // maksymalna liczba wyświetleń komunikatu
	
	//alert(visited);
    if (!visitedTip2 || visitedTip2 < maxPopupViews2) {
		WP.cookie.set('SScrVisited2', 1);
			//console.log('zoba jakie fajne przewijanie');
		 	document.getElementById("global--paging-popup").classList.add('__jsAnimation');
			visitedTip2++;
			if( !document.getElementById("global--darkSide").classList.contains('__jsVisible')) {
			 document.getElementById("global--darkSide").classList.add('__jsVisible');
			 setTimeout(function(){				
				document.getElementById("global--darkSide").classList.remove('__jsVisible');
			}, 3000);
			}
			WP.cookie.set('SScrVisited2', visitedTip2);
    } 
	else {
		document.getElementById("global--paging-popup").classList.remove('__jsAnimation');
		document.getElementById("global--darkSide").classList.remove('__jsVisible');
		//console.log('tip2 obejrzany');
	}

	// tip do przekręcania
	var visitedTip3 = WP.cookie.get('SScrVisited3');
	var maxPopupViews3 = 5; // maksymalna liczba wyświetleń komunikatu
		if (!visitedTip3 || visitedTip3 < maxPopupViews3) {
			WP.cookie.set('SScrVisited3', 1);
			if(window.innerHeight > window.innerWidth && isMobile) {		
				//alert(0);
				if ((visited) && (visited < maxPopupViews) && (visitedTip3 < maxPopupViews3)) {					
					//odczekać 3sec i wyświetlić tipa			
					setTimeout(function(){
						//alert('1a');
						document.getElementById("global--darkSide").classList.add('__jsVisible');
						document.getElementById("global--portrait-popup").classList.add('__jsAnimation');
						visitedTip3++;
					}, 3205);					
					WP.cookie.set('SScrVisited3', visitedTip3);
				}
				else if (visitedTip3 < maxPopupViews3)  {
					//poprostu wiswietlić ale też cookie
					//alert(2);
					visitedTip3++;
					document.getElementById("global--portrait-popup").classList.add('__jsAnimation');
					document.getElementById("global--darkSide").classList.add('__jsVisible');
					WP.cookie.set('SScrVisited3', visitedTip3);
					
				}		
		
			}
		}
		else {
			document.getElementById("global--portrait-popup").classList.remove('__jsAnimation');
			document.getElementById("global--darkSide").classList.remove('__jsVisible');
		}
		*/
	
});


